import React from 'react';
import { createPortal } from 'react-dom';
import { Typography, Divider } from '@mui/material';
import dayjs from 'dayjs';
import { statusIcons, supportedWhatAppFileTypes } from './WhatsappChatComponent';

export const WhatAppCommentsDisplay = ({messagesArray, setImageHover, setPosition, imageHover, position}) => {

        let groupedComments = [];
        let dateParseCurrent = null;
        let dateParsePrevious = null;
        let concatString = '';
        if (messagesArray?.length > 0) {
            groupedComments = messagesArray.reduce((acc, msgData, index) => {

                const messageText = msgData?.message?.text;
                if (index === 0) {
                    return [{ ...msgData }];
                } else if (msgData?.message?.type.toUpperCase() !== "TEXT") {
                    return [...acc, { ...msgData }];

                } else {

                    dateParseCurrent = new Date(msgData.date);
                    dateParsePrevious = new Date(messagesArray[index - 1].date);

                    if (msgData?.from === messagesArray[index - 1]?.from && ((dateParseCurrent) - (dateParsePrevious)) <= 60000) {
                        concatString = `${acc[acc.length - 1].message?.text} \n ${messageText}`;
                        return [...acc.slice(0, acc.length - 1), { ...msgData, message: { type: 'text', text: concatString } }];
                    } else {
                        return [...acc, { ...msgData }];
                    }

                }


            }, []
            );
        }
        const groupedCommentsArray = Object.values(groupedComments);

        return (
            groupedCommentsArray?.map((msgData, index) => {

                const parseDate = new Date(msgData.date);

                return (
                    <div key={`${msgData['_id']}-${index}-root-div`} className={`commentRow ${(msgData.type === 'outgoing') ? "commentRowMe" : "commentRowYou"}`}>
                        {(msgData.type === 'outgoing') ? // Operator Mode (change to Operator Name when new accounts are added)
                            <>
                                <Typography sx={{ fontSize: '1.3rem', fontWeight: 'bold', color: 'rgb(125,188,255)', marginRight: '5px', lineBreak: 'anywhere' }}>
                                    {`${msgData?.userLabel || 'Automated Message'}`}
                                </Typography>
                                <div className='DividerStampContainer'>

                                    <div className='commentDateStamp'>
                                        <Typography sx={{ fontSize: '0.75rem', fontWeight: 'bold', color: '#ffffff8a', paddingRight: '5px' }}>
                                            {`${dayjs(parseDate).fromNow()}`}
                                        </Typography>
                                    </div>
                                    <Divider orientation="horizontal" flexItem sx={{
                                        background: '#ffffff3b', width: `60%`,
                                        height: '2px', borderRadius: '16px', alignSelf: 'center'
                                    }} />

                                </div>
                            </>
                            :
                            <>
                                <Typography sx={{ fontSize: '1.3rem', fontWeight: 'bold', color: '#02f779bd', lineBreak: 'anywhere' }}>
                                    {`+${msgData.from}`}
                                </Typography>
                                <div className='DividerStampContainer'>

                                    <Divider orientation="horizontal" flexItem sx={{
                                        background: '#ffffff3b', height: '2px', width: `60%`,
                                        borderRadius: '16px', alignSelf: 'center', maxWidth: '200px'
                                    }} />
                                    <div className='commentDateStamp'>
                                        <Typography sx={{ fontSize: '0.75rem', fontWeight: 'bold', color: '#ffffff8a', paddingRight: '5px' }}>
                                            {`${dayjs(parseDate).fromNow()}`}
                                        </Typography>
                                    </div>
                                </div>
                            </>}





                        <div className={`commentElement ${(msgData.type === 'outgoing') ? "commentElementOperator" : "commentElementUser"}
                                ${((msgData.type === 'outgoing') ? "commentElementMe" : "commentElementYou")}`}
                        >

                            {(msgData.type === 'outgoing') &&
                                <div className='commentIconContainer'>
                                    {statusIcons[msgData.status]}
                                </div>}

                            <div className='commentTextContainer'>
                                {msgData?.message?.type?.toUpperCase() === "TEXT" && msgData?.message?.text?.split('\n').map((text, index) => {
                                    return (
                                        <Typography key={`${msgData['_id']}-${index}`} sx={{ fontSize: '1.2rem', fontWeight: 'bold', color: 'white' }}>
                                            {`${text}`}
                                        </Typography>
                                    );
                                })}
                                {msgData?.message?.type?.toUpperCase() === "IMAGE" &&
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', position: 'relative' }}>
                                        {msgData?.message?.caption && <Typography key={`${msgData['_id']}-img-caption`} sx={{ fontSize: '1.2rem', fontWeight: 'bold', color: 'white', marginBottom: '8px' }}>
                                            {`${msgData?.message?.caption}`}
                                        </Typography>}

                                        <img
                                            key={`${msgData['_id']}`}
                                            alt='WhatsappImage'
                                            onClick={() => {
                                                const fileUrlArray = msgData?.message?.blobUrl.split('/');
                                                const link = document.createElement('a');
                                                link.href = msgData?.message?.blobUrl;
                                                link.download = `${fileUrlArray[fileUrlArray.length - 1].split('?')[0]}`; // Set to desired filename
                                                document.body.appendChild(link);
                                                link.click();
                                                document.body.removeChild(link);
                                            }}

                                            onMouseMove={(e) => {
                                                setImageHover(index);
                                                //const rect = e.target.getBoundingClientRect();
                                                setPosition({ x: e.clientX, y: e.clientY });
                                            }}
                                            onMouseLeave={() => setImageHover(-1)}
                                            src={msgData?.message?.blobUrl}
                                            className={`whatsAppImage`} />

                                        {imageHover === index && createPortal(
                                            <img
                                                key={`${msgData['_id']}-hover`}
                                                alt='WhatsappImage'
                                                src={msgData?.message?.blobUrl}
                                                style={{
                                                    position: 'fixed',
                                                    left: `${position.x}px`,
                                                    top: `${position.y - 400}px`
                                                }}
                                                className={`whatsAppImageHover`} />,
                                            document.getElementById('portal-root'), `portal-${index}`
                                        )}


                                    </div>}
                                {supportedWhatAppFileTypes.includes(msgData?.message?.type?.toUpperCase()) &&
                                    <div>
                                        {msgData?.message?.caption && <Typography key={`${msgData['_id']}`} sx={{ fontSize: '1.2rem', fontWeight: 'bold', color: 'white' }}>
                                            {`${msgData?.message?.caption}`}
                                        </Typography>}
                                        <a
                                            href={msgData?.message?.blobUrl}
                                            download
                                            style={{ color: 'white' }}
                                        >
                                            {`${msgData?.message?.blobName}`}
                                        </a>

                                    </div>}
                            </div>

                        </div>
                    </div>
                );


            })
        );

}
